import Loader from 'components/Loader/Loader';
import Redirecting from 'components/Redirecting/Redirecting';
import { useSessionContext } from 'context/SessionProvider/SessionProvider';
import LinkedAdsTable from 'features/direct/ad/components/LinkedAdsTable/LinkedAdsTable';
import { History } from 'history';
import {
  AdLegacy,
  useChannelAssociatedAdsLegacyQuery,
} from 'interfaces/generated.types';
import React from 'react';

const ChannelAssociatedAdsTable = ({
  history,
  channelId,
}: {
  history: History;
  channelId: string;
}) => {
  const {
    state: {
      user: { activeTerritory },
    },
  } = useSessionContext();

  const { loading, data, error } = useChannelAssociatedAdsLegacyQuery({
    variables: {
      id: channelId,
      territories: [activeTerritory!],
    },
    errorPolicy: 'all',
  });

  if (loading) return <Loader />;

  if (!loading && error) return <Redirecting history={history} />;

  return (
    <LinkedAdsTable
      ads={(data?.channelLegacy?.associatedAds as AdLegacy[]) || []}
      history={history}
    />
  );
};

export default ChannelAssociatedAdsTable;
